<template>
    <div style="background-color: #f5f5f5;">
        <!-- 图片 -->
        <div class="bg">
            <div class="sub-title">Solution</div>
            <div class="title">解决方案</div>
        </div>
        <div class="m-3">
            <div class="flex-row flex-wrap">
                <div class="img-item" @click="select(index)" :class="{ 'img-active': index == selectIndex }" v-for="(item, index) in industryData">
                    <div class="img">

                        <img :src="http.ipAddress+item.industry.filePathSelected"
                                style="width: 50px;" alt=""  v-if="index == selectIndex">

                            <img :src="http.ipAddress+item.industry.filePath"
                                style="width: 50px;" alt=""  v-else>
                            
                    </div>
                    
                </div>
            </div>
            <div>
                <div style="height: 20px;">

                </div>
                <!-- <div class="chache">
                    <div class="af"></div>
                    <div class="line">
                    </div>
                    <div class="chachee">
                        <div style="font-size: 14px;font-weight: 700;">叉车</div> 
                        <div style="font-size: 12px;">Forklift truck</div> 
                    </div>
                </div> -->
            </div>
            <div>
                <div>
                    <img :src="http.ipAddress+bannerFilePath" style="width: 100%;margin-bottom: 30px;" alt="">
                   
                </div>
              
                <div class="flex-row flex-wrap justify-between">
                    <div  class="products-item flex-column align-center justify-center" :class="{ 'active': index == 0 }"
                        v-for="(item, index) in industryData[selectIndex].productInfos">
                        <img :src="http.ipAddress+item.filePath"
                            style="width: 150px;height: 150px;" alt=""  @click="page(item.productType,item.id)">
                       
                        <div class="item-name">{{ item.productName }}</div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            selectIndex: 0,
            bannerFilePath:"",
            industryData:[

            ],
            controllerData:[
                {
                    name:"叉车",
                    imgselect:"icons_1.png",
                    img:"icons_1_1.png",
                    path:require("../../assets/img/叉车.jpg"),
                        schemeData:[
                            {
                                nmae:"D1M+D1S总成",
                                img:"叉车-1-合力总成 D1M+D1S-3-3.5吨电控总成.png",
                                path:"",
                                index:"0",
                                switch:1
                            },{
                                nmae:" G2油改电总成",
                                img:"叉车-2 龙工g2-80v-3-3.5吨点控总成.png",
                                path:"",
                                index:"2",
                                switch:1
                            },{
                                nmae:"D1M+D1L总成",
                                img:"叉车-4-FJ D1M + FJ D1L 3 35吨电控总成.png",
                                path:"",
                                index:"0",
                                switch:1
                            },{
                                nmae:"S2+G1三支点总成",
                                img:"叉车-5-G1S2 2.5吨双驱三支点.png",
                                path:"",
                                index:"1",
                                switch:1
                            },
                            
                        ]
                },
                {
                    name:"高空作业平台",
                    imgselect:"icons_2.png",
                    img:"icons_2_1.png",
                    path:require("../../assets/img/高空作业平台.jpg"),
                        schemeData:[
                            {
                                nmae:"G2 80V 高机总成",
                                img:"叉车-2 龙工g2-80v-3-3.5吨点控总成.png",
                                path:"",
                                index:"2",
                                switch:1
                            },
                            // {
                            //     nmae:"FJ-S1系列电动车辆控制系统",
                            //     img:"S1.png",
                            //     path:"",
                            //     index:"6",
                            //     switch:1
                            // },
                            // {
                            //     nmae:"FJ-S1X系列电动车辆控制系统",
                            //     img:"S1X.png",
                            //     path:"",
                            //     index:"5",
                            //     switch:1
                            // },
                            {
                                nmae:"S1M 80V 五交总成",
                                img:"高空-9 FJ S1M25-28米曲臂式高空作业车点控总成.png",
                                path:"",
                                index:"6",
                                switch:1
                            },{
                                nmae:"S1M 80V 五交总成",
                                img:"叉车-10- fjzc-s1-l_m-001-xg-80v-03 已拆件.61.png",
                                path:"",
                                index:"6",
                                switch:1
                            },
                            {
                                nmae:" S1X高机方案",
                                img:"高空-11- S1X6-16米剪叉式高空作业平台电控及仪表方案.png",
                                path:"",
                                index:"5",
                                switch:1
                            }
                        ]
                    
                    
                },
                {
                    name:"高尔夫球车、观光车",
                    imgselect:"icons_3.png",
                    img:"icons_3_1.png",
                    path:require("../../assets/img/观光车.jpg" ),
                        schemeData:[
                            // {
                            //     nmae:"FJ-S1系列电动车辆控制系统",
                            //     img:"S1.png",
                            //     path:"",
                            //     index:"6",
                            //     switch:1
                            // },{
                            //     nmae:"FJ-G1系列电动车辆控制系统",
                            //     img:"G1.png",
                            //     path:"",
                            //     index:"1",
                            //     switch:1
                            // },
                            {
                                nmae:"S1S总成",
                                img:"球车-6-S1S高尔夫球车电控总成.png",
                                path:"",
                                index:"6",
                                switch:1
                            },{
                                nmae:"G1内置接触器单控总成",
                                img:"球车-7-G1 高尔夫球车点控总成.png",
                                path:"",
                                index:"1",
                                switch:1
                            },{
                                nmae:"S1L总成",
                                img:"球车-12-朗晴.jpg",
                                path:"",
                                index:"6",
                                switch:1
                            }
                        ]
                },
                {
                    name:"割草机",
                    imgselect:"icons_4.png",
                    img:"icons_4_1.png",
                    path:require("../../assets/img/割草机.jpg"),
                        schemeData:[
                            {
                                nmae:"FJ-S0系列电动车辆控制系统",
                                img:"S0.png",
                                path:"",
                                index:"3",
                                switch:1
                            },{
                                nmae:"FJ-S1系列电动车辆控制系统",
                                img:"S1.png",
                                path:"",
                                index:"6",
                                switch:1
                            }
                        ]
                },
                {
                    name:"仓储车",
                    imgselect:"icons_5.png",
                    img:"icons_5_1.png",
                    path:require("../../assets/img/仓储车辆.jpg"),
                        schemeData:[
                        // {
                        //         nmae:"D1M+D1S总成",
                        //         img:"叉车-1-合力总成 D1M+D1S-3-3.5吨电控总成.png",
                        //         path:"",
                        //         index:"0",
                        //         switch:1
                        //     },{
                        //         nmae:" G2油改电总成",
                        //         img:"叉车-2 龙工g2-80v-3-3.5吨点控总成.png",
                        //         path:"",
                        //         index:"2",
                        //         switch:1
                        //     },{
                        //         nmae:"D1M+D1L总成",
                        //         img:"叉车-4-FJ D1M + FJ D1L 3 35吨电控总成.png",
                        //         path:"",
                        //         index:"0",
                        //         switch:1
                        //     },{
                        //         nmae:"S2+G1三支点总成",
                        //         img:"叉车-5-G1S2 2.5吨双驱三支点.png",
                        //         path:"",
                        //         index:"1",
                        //         switch:1
                        //     },
                            {
                                nmae:"FJ-S1X系列电动车辆控制系统",
                                img:"S1X.png",
                                path:"",
                                index:"5",
                                switch:1
                            },{
                                nmae:"FJ-S0系列电动车辆控制系统",
                                img:"S0.png",
                                path:"",
                                index:"3",
                                switch:1
                            },{
                                nmae:"FJ-MS",
                                img:"MS.png",
                                path:"",
                                index:"3",
                                switch:2
                            }
                        ]
                },
                {
                    name:"环卫车、牵引车",
                    imgselect:"icons_6.png",
                    img:"icons_6_1.png",
                    path:require("../../assets/img/环卫车.jpg"),
                        schemeData:[
                            {
                                nmae:"G2 总成",
                                img:"叉车-2 龙工g2-80v-3-3.5吨点控总成.png",
                                path:"",
                                index:"2",
                                switch:1
                            },
                            {
                                nmae:"G1 内置接触器单控总成",
                                img:"球车-7-G1 高尔夫球车点控总成.png",
                                path:"",
                                index:"1",
                                switch:1
                            },
                            // {
                            //     nmae:"FJ-S1系列电动车辆控制系统",
                            //     img:"S1.png",
                            //     path:"",
                            //     index:"6",
                            //     switch:1
                            // },
                            {
                                nmae:"S1总成",
                                img:"牵引车-8-合力S1-48V牵引车 DB20车型.png",
                                path:"",
                                index:"6",
                                switch:1
                            }
                        ]
                },
                {
                    name:"农机",
                    imgselect:"icons_7.png",
                    img:"icons_7_1.png",
                    path:require("../../assets/img/农机.jpg"),
                        schemeData:[
                            {
                                nmae:"FJ-S1系列电动车辆控制系统",
                                img:"S1.png",
                                path:"",
                                index:"6",
                                switch:1
                            }
                        ]
                },
                {
                    name:"船舶",
                    imgselect:"icons_8.png",
                    img:"icons_8_1.png",
                    path:require("../../assets/img/船舶.jpg"),
                        schemeData:[
                            {
                                nmae:"FJ-S1系列电动车辆控制系统",
                                img:"S1.png",
                                path:"",
                                index:"6",
                                switch:1
                            }
                        ]
                },
                // {
                //     name:"叉车",
                //     imgselect:"icons_9.png",
                //     img:"icons_9_1.png",
                //     path:require("../../assets/img/叉车.jpg"),
                //         schemeData:[
                //             {
                //                 nmae:"FJ-D1系列电动车辆控制系统",
                //                 img:"D1.png",
                //                 path:"",
                //                 index:"0"
                //             },{
                //                 nmae:"FJ-S2系列电动车辆控制系统",
                //                 img:"S2.png",
                //                 path:"",
                //                 index:"7"
                //             },{
                //                 nmae:"FJ-G2系列电动车辆控制系统",
                //                 img:"G2.png",
                //                 path:"",
                //                 index:"2"
                //             }
                //         ]
                // }
            ],
        }
    },
    methods: {
        select(index) {
            this.selectIndex = index
            this.bannerFilePath=this.industryData[index].industry.industryBanner;
            this.$store.commit('setSolutionIndustry', index);
        },
        page(switchValue,index) {
            debugger
            if(switchValue==3){
                this.$router.push({path:'/productAssembly', query: {index}});
            }else{
                this.$router.push({path:'/productsDetail', query: {switch:switchValue,index}});
            }
           
        },
    }, mounted() {
            debugger
            let that=this;
            this.http.post("/api/FJ_Industry/GetAllIndustry",JSON.stringify({})).then((result)=>{
                debugger
            let objResult= eval(result);
            let iCode= objResult.code;
            if(iCode==0){
                debugger
                that.selectIndex=that.$store.getters.getSolutionIndustry();
                    that.industryData=objResult.data;
                    if(that.industryData.length>0){
                        that.bannerFilePath=that.industryData[that.selectIndex].industry.industryBanner;
                    }
                }
            });
        }
}
</script>

<style scoped>
.bg {
    background: url('../../assets/img/solutionbanner.jpg') no-repeat;
    background-size: 100%;
    height: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.m-3 {
    margin: 30px;
}

.video {
    background-color: #00585252;
    height: 200px;
    width: 100%;
}

.sub-title {
    display: inline-block;
    background-color: #0AA00A;
    color: #fff;
    border-radius: 5px;
    border-top-right-radius: 0;
    font-size: 12px;
    padding: 2px 5px;
}

.title {
    font-size: 20px;
    font-weight: 700;
    margin-top: 5px;
}

.mt-1 {
    margin-top: 10px;
}

.mt-3 {
    margin-top: 30px;
}

.content {
    margin-top: 10px;
    text-indent: 2rem;
}

.product-item {
    width: 48%;
    margin-bottom: 10px;
    border: 1px solid #eee
}

.border {
    border-top: 1px solid #eee;
    padding: 5px 0;
}

.product-img {
    /* background-color: #eee; */
    width: 100%;
    height: 100px;
}

.customer-item {
    height: 100px;
    margin-bottom: 10px;
}

.customer-left {
    border-bottom: 1px dashed #0AA00A;
    width: 65%;
}

.customer-right {
    width: 30%;
    background-color: #0AA00A;
    color: #fff;
}

.project-item {
    width: 50%;
    margin-bottom: 30px;

}

.input {
    border-radius: 10px;
    padding: 5px;
    width: 100px;
}

.item {
    width: 25%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    padding: 5px;
}

.img {
    border: 1px solid #999;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    width: 60px;
    height: 60px;
}

.products-item {
    width: 48%;
    background-color: #fff;
    box-sizing: border-box;
    border: 1px solid #eee;
    margin-bottom: 15px;
    border: 1px solid transparent;
}

.item-name {
    padding: 5px 0;
}

.chache {
    background-color: #ffff;
}

.chachee {
    width: 25%;
    background-color: #f5f5f5;
    height: 80px;
    padding-top: 20px;
}

.line {
    width: 25%;
    background-color: #0AA00A;
    height: 1px;
    display: block;
    flex-direction: row;
    position: relative;
}

.line::before {
    content: '';
    top: -5px;
    left: 35px;
    /* display: none; */
    position: absolute;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid #0AA00A;
    cursor: pointer;

}
</style>


// WEBPACK FOOTER //
// src/views/scheme/m_index.vue